import { AbsoluteModelPath, ModelPath, PathTokens } from "../../../../../Common/ModelPath/ModelPath";
import { MatchKind } from "../../../../../Common/ModelPath/PathMatcher";
import { ModelPathBuilder } from "../../../../../Common/ModelPath/ModelPathBuilder";

export class CalculationFunctionDependency {
    private readonly targetPath: AbsoluteModelPath;
    private readonly dependencyPath: AbsoluteModelPath;

    public constructor(targetPath: AbsoluteModelPath, dependencyPath: AbsoluteModelPath) {
        this.targetPath = targetPath;
        this.dependencyPath = dependencyPath;
    }

    public isMatchToPath(modelPath: ModelPath): boolean {
        return this.dependencyPath.isIncludes(modelPath);
    }

    public getDependencyPath() {
        return this.dependencyPath;
    }

    public getTargetByChangedPath(changedPath: ModelPath): undefined | ModelPath {
        const changedDependencyPath = new ModelPathBuilder(false);
        const dependencyMatching = this.dependencyPath.matchFor(changedPath);
        for (const dependencyMatch of dependencyMatching) {
            if (dependencyMatch.kind === MatchKind.MatchedPath) {
                changedDependencyPath.append(dependencyMatch.prefix);
            } else if (dependencyMatch.kind === MatchKind.MatchedMultiplicity) {
                if (PathTokens.isInstanceToken(dependencyMatch.target)) {
                    if (dependencyMatch.source === PathTokens.current) {
                        changedDependencyPath.append(dependencyMatch.target);
                    } else if (dependencyMatch.source === PathTokens.each) {
                        changedDependencyPath.append(PathTokens.each);
                    }
                } else {
                    throw new Error("Changed path must be resolved path");
                }
            } else {
                return undefined;
            }
        }

        return this.getTargetByChangedChildrenPath(changedDependencyPath.toPath());
    }

    public getTargetByChangedChildrenPath(changedPath: ModelPath): undefined | ModelPath {
        const resultPath = new ModelPathBuilder(false);
        const pathMatching = this.targetPath.matchFor(changedPath);
        for (const match of pathMatching) {
            if (match.kind === MatchKind.MatchedPath) {
                resultPath.append(match.prefix);
            } else if (match.kind === MatchKind.MatchedMultiplicity) {
                if (PathTokens.isMultiToken(match.source) && PathTokens.isMultiToken(match.target)) {
                    resultPath.append(match.source);
                } else if (PathTokens.isSimpleToken(match.source) && PathTokens.isMultiToken(match.target)) {
                    resultPath.append(match.source);
                } else if (PathTokens.isMultiToken(match.source) && PathTokens.isSimpleToken(match.target)) {
                    resultPath.append(match.target);
                }
            } else {
                if (match.source != undefined) {
                    resultPath.append(match.source);
                }
                break;
            }
        }

        return resultPath.toPath();
    }
}
